// import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const supportingDocsColumnDefs = () => [
  {
    Header: 'File Name',
    accessor: 'originalFileName',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-50p',
  },
  {
    Header: 'Document Type',
    accessor: 'typeDescription',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-20p',
  },
  {
    Header: 'Uploaded At',
    accessor: 'uploadDate',
    disableFilters: true,
    disableSortBy: true,
    className: 'col-20p',
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default supportingDocsColumnDefs;
